import i18n from '../../locale/i18n';

/**
 * Get the user's language preference from i18n
 * Converts i18next language code to backend format
 * @returns 'spanish' or 'english'
 */
export const getLanguageFromStorage = (): string => {
  const currentLanguage = i18n.language;
  return currentLanguage === 'es' ? 'spanish' : 'english';
};
